module.exports = __webpack_public_path__ + "static/media/accesorios.da303946.png";